import { render, staticRenderFns } from "./WarnModal.vue?vue&type=template&id=6c7df0b7&scoped=true&"
import script from "./WarnModal.vue?vue&type=script&lang=ts&"
export * from "./WarnModal.vue?vue&type=script&lang=ts&"
import style0 from "./WarnModal.vue?vue&type=style&index=0&id=6c7df0b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7df0b7",
  null
  
)

export default component.exports